/**
 * 请求模块
 */
import axios from "axios";
import store from "@/store";
import {Toast} from "vant";
import JSONBig from "json-bigint";
import {Message} from "element-ui";
import config from "@/config";
import {objCoverFormData} from "@/utils/form";
import {DOMAIN} from "@/utils/platform-config"
import Cookies from "js-cookie";

const request = axios.create({
    // 接口的基准路径
    // baseURL: config.baseUrl,
    timeout: 300000,
    baseURL: config.baseURL,
    transformResponse: [
        function (data) {
            try {
                return JSONBig.parse(data);
            } catch (err) {
                return data;
            }
        }
    ],
});
// 请求拦截器
request.interceptors.request.use(
    function (config) {
        const {user} = store.state;
        if (user) {
            config.headers.Authorization = `Bearer ${user}`;
        }
        config.headers.CustomDomain = DOMAIN
        return config;
    },
    function (error) {
        console.log(error, "error")
        return Promise.reject(error);
    }
);

/**
 * 登录过期错误
 */
class LoginOverdue extends Error {
    constructor(msg) {
        super(msg);
        this.name = "LoginOverdue";
    }
}

function yznDebugInfo(obj) {
    if (config.isYznDebug) {
        let {
            url,
            method,
            params
        } = obj
        let args = {
            url,
            method,
            params
        }
        console.info(JSON.stringify(args))
    }
}

function showMessage(msg) {
    if (location.pathname.startsWith("/mobile-exam")) {
        Toast(msg)
    } else {
        Message(msg)
    }
}

// 响应拦截器
request.interceptors.response.use(
    (response) => {
        // //   要根据success的成功与否决定下面的操作
        if (response.status === 200) {
            // if (response.data.code === -1) {
            //     showMessage(response.data.msg)
            // }
            return response;
        } else {
            // 业务已经错误了 还能进then ? 不能 ！ 应该进catch
            // 提示错误消息
            showMessage("服务器繁忙，请稍后再试！");
        }
        throw response;
    },
    (error) => {
        // error 信息 里面 response的对象
        if (
            error.response?.data?.msg === "401" ||
            error instanceof LoginOverdue
        ) {
            // 登出action 删除token
            store.commit("setUser", null);
            store.commit("setUserInfo", null);
            if (location.pathname.startsWith("/mobile")) {
                const query = location.href.slice(location.href.lastIndexOf("?"))
                const suffix = location.origin.startsWith("192") ? "" : ".html"
                location.href = `/mobile-exam${suffix}#/login${query}`;
            } else {
                // location.href = "/";
            }
        } else {
            // 提示错误信息
            if (error.isAxiosError) {
                if (error.response?.status === 401) {
                    store.commit("setUser", null);
                    store.commit("setUserInfo", null);
                    if (location.pathname.startsWith("/mobile")) {
                        const query = location.href.slice(location.href.lastIndexOf("?"))
                        const suffix = location.origin.startsWith("192") ? "" : ".html"
                        location.href = `/mobile-exam${suffix}#/login${query}`;
                    } else {

                        // location.href = "/";
                    }
                    showMessage("未登录，或登录过期，请重新登录")
                } else {
                    showMessage("网络错误，请稍后再试");
                }
            } else if (error.message === "canceled") {
                console.log("request cancel")
            } else {
                showMessage(error.response.data?.msg);
            }
        }
        throw error;
    }
);

export function requestData(args) {
    return request(args).then((res) => {
        const {data} = res;
        if (data.code !== 100) {
            showMessage(data.msg || "未知错误")
            return Promise.reject(data);
        }
        if (args.needRaw) {
            return data
        }
        return data.data;
    });
}

/**
 * 封装postForm请求
 * postJson
 */
export const postForm = (url, params) => {
    return request({
        url: url,
        method: "POST",
        headers: {"Content-Type": "multipart/form-data"},
        data: objCoverFormData(params),
        $_isFormData: true
    });
};
export const get = (url, params, needRaw = false) => {
    return requestData({
        url: url,
        method: "GET",
        params,
        needRaw
    });
};
export const post = (url, params, needRaw = false, data) => {
    return requestData({
        url: url,
        method: "POST",
        params,
        data,
        needRaw
    });
};

export const postFormData = (url, params, progressEvent) => {
    let form = new FormData();
    for (let k in params) {
        form.append(k, params[k]);
    }
    return requestData({
        url,
        method: "POST",
        data: form,
        onUploadProgress: progressEvent,
        headers: {"Content-Type": "multipart/form-data"}
    });
};

export default request;
